export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-lg font-heading text-accent-300">老子影视网</span>
            <p className="mt-3 text-xs text-secondary-200 leading-relaxed">
              高清电影、高清电视剧免费在线观看平台。超清画质不缓冲秒开，全集播放，畅享流畅观影体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-secondary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-secondary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-secondary-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '精选推荐', href: '#media' },
                { label: '热门榜单', href: '#ranking' },
                { label: '最新更新', href: '#updates' },
                { label: '专题合集', href: '#index' },
                { label: '热门话题', href: '#topics' },
              ].map((l) => (
                <a key={l.href} href={l.href} className="block text-xs text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer">
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">关于我们</h4>
            <div className="space-y-2">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '平台优势', href: '#features' },
                { label: '联系我们', href: '#contact' },
                { label: '移动观影', href: '#app' },
              ].map((l) => (
                <a key={l.href} href={l.href} className="block text-xs text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer">
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">合作伙伴</h4>
            <p className="text-xs text-secondary-300 leading-relaxed">
              更多合作伙伴正在加入中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            &copy; {new Date().getFullYear()} 老子影视网. 本站所有资源均来自互联网，仅供交流学习使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-secondary-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#hero" className="text-xs text-secondary-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#hero" className="text-xs text-secondary-300 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}